<template>
  <div class="w-full bg-[#fff8e1] border border-[#ffc107] rounded-md p-4 mb-4 flex items-center gap-3">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6 text-[#ffc107] shrink-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
    <div class="text-[#043f42] font-['Raleway',sans-serif] text-sm flex-1">
      <strong>This cohort is archived.</strong> Mutating actions are disabled. Read-only actions (like exports) remain available.
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArchivedCohortBanner'
}
</script>
